import React, { useMemo } from "react";
import { Box } from "@mui/material";
import {
  sharedNotificationStyles,
  CloseIcon,
} from "../PushNotificationPreview/sharedStyles";

interface PushNotificationToastProps {
  title: string;
  content: string;
  appName?: string;
  onClose: () => void;
}

const PushNotificationToast: React.FC<PushNotificationToastProps> = ({
  title,
  content,
  appName = "Shipeezi",
  onClose,
}) => {
  const notificationTimestamp = useMemo(() => {
    const now = new Date();
    return now.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }, []);

  const metaLine = useMemo(
    () => `${appName} · ${notificationTimestamp}`,
    [appName, notificationTimestamp]
  );

  return (
    <Box
      style={{
        ...sharedNotificationStyles.pushNotificationCard,
        animation: "slideInUp 0.3s ease-out",
      }}
    >
      <Box style={sharedNotificationStyles.pushNotificationCardContent}>
        <Box style={sharedNotificationStyles.pushNotificationCardText}>
          <Box style={sharedNotificationStyles.pushNotificationCardMeta}>{metaLine}</Box>
          <Box style={sharedNotificationStyles.pushNotificationCardTitle}>{title}</Box>
          {content && (
            <Box style={sharedNotificationStyles.pushNotificationCardBody}>{content}</Box>
          )}
        </Box>
        <CloseIcon
          style={sharedNotificationStyles.pushNotificationCardCloseButton}
          onClick={onClose}
        />
      </Box>

      <style>
        {`
          @keyframes slideInUp {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default PushNotificationToast;
